import { render, staticRenderFns } from "./mobilmenu.vue?vue&type=template&id=329bd077&"
import script from "./mobilmenu.vue?vue&type=script&lang=js&"
export * from "./mobilmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports